module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page page-lesgeven",
    attrs: {
      "id": "page-lesgeven"
    }
  }, [_c('div', {
    staticClass: "page__content"
  }, [_vm._m(0), _vm._v(" "), _c('h1', [_vm._v("In welk vak zou je willen lesgeven?")]), _vm._v(" "), _c('div', {
    staticClass: "container list-select"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12-sm"
  }, [_c('p', {
    staticClass: "form__label"
  }, [_vm._v("Ik wil lesgeven in")]), _vm._v(" "), _c('typeahead', {
    key: "is-not-docent-interesse-vak",
    attrs: {
      "items": _vm.vakken,
      "property": "vak"
    },
    on: {
      "select": _vm.selectVak
    }
  })], 1)]), _vm._v(" "), (_vm.currentVak) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12-sm"
  }, [_c('div', {
    staticClass: "result-box"
  }, [_c('p', [_vm._v(_vm._s(_vm.commentSelected))]), _vm._v(" "), (_vm.currentVak) ? _c('div', [_c('page-next-button', {
    on: {
      "click": _vm.nextHandler
    }
  })], 1) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br')])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page__icon-wrapper"
  }, [_c('i', {
    staticClass: "fa fa-graduation-cap",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67635ecd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/page-lesgeven.vue
// module id = 147
// module chunks = 0